var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PMain',{attrs:{"dataKey":_vm.key},model:{value:(_vm.themeData),callback:function ($$v) {_vm.themeData=$$v},expression:"themeData"}},[_c('v-row',[_c('v-col',[_vm._v(" Clearing All ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }